/**
 * NOTE: This is an AUTO GENERATED file from the Translation strings. If new languages are added,
 * then this file needs to be regenerated from the source CHATBOT translations. If used in Pleased
 * Application, only use the `language.ts` file generated by this method.
 *
 * NOTE: This file is created via AppScript. You can edit the JS code it in the link below.
 *
 * @see https://docs.google.com/spreadsheets/d/1cuSl1W_ZTA2fVdjJziyk7j5oIioBrKpLzd8Zwz5t8X8
 * @author Aakash More
 */

/**
 * Static list of languages supported by the pleased app.
 */
export const LANGUAGES = {
  'af-za': {
    code: 'af-za',
    englishName: 'Afrikaans (South Africa)',
    locale: 'af-za',
    name: 'Afrikaans (Suid-Afrika)',
  },
  en: {
    code: 'en',
    englishName: '',
    locale: 'en',
    name: 'English',
  },
  es: {
    code: 'es',
    englishName: 'Spanish',
    locale: 'es',
    name: 'Español',
  },
  'es-mx': {
    code: 'es-mx',
    englishName: 'Spanish (Mexican)',
    locale: 'es-mx',
    name: 'Español (mexicano)',
  },
  fr: {
    code: 'fr',
    englishName: 'French',
    locale: 'fr',
    name: 'Français',
  },
  'fr-cm': {
    code: 'fr-cm',
    englishName: 'Cameroonian French',
    locale: 'fr-cm',
    name: 'Français',
  },
  pt: {
    code: 'pt',
    englishName: 'Brazilian Portuguese',
    locale: 'pt',
    name: 'Português do Brasil',
  },
  'pt-mz': {
    code: 'pt-mz',
    englishName: 'Mozambican Portuguese',
    locale: 'pt-mz',
    name: 'Português de Moçambique',
  },
  sw: {
    code: 'sw',
    englishName: 'Swahili',
    locale: 'sw',
    name: 'Kiswahili',
  },
} as const;

export type SupportedLanguages = keyof typeof LANGUAGES;
